import type { RoleActorType } from './types';

export const GROUP_ID: RoleActorType = 'ATLASSIAN_GROUP_ROLE_ACTOR';

export const UPGRADE_URL = '/admin/billing/applications';

export const LEARN_MORE_LINK =
	'https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans';

export const ADMIN_USER_MANAGEMENT_LINK = '/admin/users';

// analytics
export const PEOPLE_PAGE_APP_NAME = 'project-settings-apps.access-page';
export const TIME_TO_LOAD_MARK_KEY = 'timeToLoad';
export const READY_MARK_KEY = 'readyToInteract';
export const ANALYTICS_ACCESS_SOURCE = 'access';
export const TRACK_EVENT_ACTION = 'project updated';

export const LOAD_START_MARK_KEY_PROJECT_ACCESS = 'PROJECT_ACCESS_LOAD_START_MARK_KEY';

export const ACCESS_TYPES = {
	OPEN: 'open',
	LIMITED: 'limited',
	PRIVATE: 'private',
} as const;

export const TEAM_NAME = 'olympus';
export const PACKAGE_NAME = 'jiraUsersAndRoles';
